var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareRoomBadges(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0443 7.96069L17.0498 7.95601L17.0551 7.95118C17.6269 7.43136 17.6015 6.56934 17.0723 6.04016L17.0588 6.02666L17.0443 6.01423L11.5462 1.29712C11.5459 1.29681 11.5455 1.29651 11.5452 1.29621C10.7332 0.593958 9.5 1.21033 9.5 2.26871V4.24687C7.16157 4.30723 4.9994 4.6008 3.37909 5.45976C2.50115 5.92517 1.77302 6.56116 1.26784 7.41937C0.763332 8.27643 0.5 9.32309 0.5 10.5812C0.5 12.6774 1.82097 14.7204 3.29493 15.7946C3.69876 16.1009 4.19151 16.0362 4.51954 15.8175C4.85315 15.5951 5.10282 15.1542 4.94628 14.6518C4.2561 12.4278 4.49461 11.2649 5.21697 10.6019C5.60258 10.2481 6.17933 9.97985 6.99008 9.79923C7.68265 9.64493 8.51849 9.56047 9.5 9.5297V11.7375C9.5 12.7856 10.749 13.3674 11.5453 12.6786C11.5456 12.6784 11.5459 12.6781 11.5462 12.6778L17.0443 7.96069Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareRoomBadges);
export default __webpack_public_path__ + "static/media/share-room-badges.8f2245cc21e0b25bbf60076acfdc0daa.svg";
export { ForwardRef as ReactComponent };